import { gql } from "@apollo/client";
import moment from "moment";

const SAVE_VISITA = gql`
    mutation saveVisita($visitaInput: AddVisitaInput!){
        saveVisita(visitaInput: $visitaInput) {
            success
            error
            valorEsperado {
                idVisita
                idEstado
            }
        }
    }
`;

export default SAVE_VISITA;

export const adaptAddVisitaInput = (data, finalizada) => ({
    idVisita: data?.idVisita,
    idEvaluacion: data?.idEvaluacion,
    direccion: data?.direccion,
    posX: data?.posX,
    posY: data?.posY,
    idFrecuencia: data?.idFrecuencia,
    idTipoProfesional: data?.idTipoProfesional,
    idFiguraProfesional: data?.idFiguraProfesional,
    idProfesional: data?.idProfesional,
    idComboVisitaValorTipoVisita: data?.idComboVisitaValorTipoVisita,
    idEstado: data?.idEstado,
    fechaVisita: moment(data?.fechaVisita).format("YYYY-MM-DD HH:mm:ss"),
    tiempoEspera: data?.tiempoEspera,
    explicacion: data?.explicacion,
    idComboVisitaValorFormaVisita: data?.idComboVisitaValorFormaVisita || 3,
    idComboVisitaValorPacienteDomicilio: data?.idComboVisitaValorPacienteDomicilio,
    idDatosGeneralesRI: data?.idDatosGeneralesRI || null,
    idUltimaVisita: data?.idUltimaVisita,
    evolucion: data?.evolucion,
    codigoAtencion: data?.codigoAtencion,
    idComboVisitaValorInterlocutor: data?.idComboVisitaValorInterlocutor,
    nombreCompleto: data?.nombreCompleto,
    dNI: data?.dNI,
    email: data?.email,
    capacitacion: !!data?.capacitacion,
    justificacionHoras: data?.justificacionHoras,
    conformidad: !!data?.conformidad,
    obsConformidad: data?.obsConformidad,
    kinesioRespiratoria: !!data?.kinesioRespiratoria,
    kinesioMotora: !!data?.kinesioMotora,
    finalizada: !!finalizada,
    esVisitaCero: !!data?.esVisitaCero,
    periodo: data?.periodoCoordinador || null,
    desdeCoordinacion: !!data?.desdeCoordinacion
});